import styled from 'styled-components';
import { Info } from 'react-feather';

import { colours } from 'themes/default';

export const StyledBreakdownValue = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 8px;
`;

export const StyledBreakdownButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${colours.Shades.BlueShade40};
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0;
`;

export const StyledBreakdownIcon = styled(Info)`
  display: block;
`;

export const ScreenReaderText = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const StyledBreakdownModal = styled.div`
  color: ${colours.Greyscale.CharcoalGrey};
`;

export const StyledBreakdownModalTitle = styled.h2`
  color: ${colours.Shades.BlueShade40};
  font-size: 32px;
  line-height: 1.2;
  margin: 0 0 32px;
`;

export const StyledBreakdownSection = styled.section`
  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const StyledBreakdownSectionTitle = styled.h3`
  font-size: 24px;
  margin: 0 0 16px;
`;

export const StyledCarrierFee = styled.p`
  font-size: 16px;
  line-height: 1.4;
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
